'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SET_ITEMS_COUNT = exports.SET_PAGE_SIZE = exports.GO_TO_PAGE = exports.END = exports.HOME = exports.PREV_PAGE = exports.NEXT_PAGE = undefined;
exports.is = is;
exports.nextPage = nextPage;
exports.prevPage = prevPage;
exports.home = home;
exports.end = end;
exports.goToPage = goToPage;
exports.setPageSize = setPageSize;
exports.setItemsCount = setItemsCount;

var _utils = require('./../../utils');

var NEXT_PAGE = exports.NEXT_PAGE = 'paging.nextPage';
var PREV_PAGE = exports.PREV_PAGE = 'paging.prevPage';
var HOME = exports.HOME = 'paging.home';
var END = exports.END = 'paging.end';
var GO_TO_PAGE = exports.GO_TO_PAGE = 'paging.goToPage';
var SET_PAGE_SIZE = exports.SET_PAGE_SIZE = 'paging.setPageSize';
var SET_ITEMS_COUNT = exports.SET_ITEMS_COUNT = 'paging.setItemsCount';

function is(action) {
    switch (action.type) {
        case NEXT_PAGE:
        case PREV_PAGE:
        case HOME:
        case END:
        case GO_TO_PAGE:
        case SET_PAGE_SIZE:
        case SET_ITEMS_COUNT:
            return true;
        default:
            return false;
    }
}

function nextPage(area) {
    return {
        area: area,
        type: NEXT_PAGE
    };
}

function prevPage(area) {
    return {
        area: area,
        type: PREV_PAGE
    };
}

function home(area) {
    return {
        area: area,
        type: HOME
    };
}

function end(area) {
    return {
        area: area,
        type: END
    };
}

function goToPage(area, pageIndex) {
    return {
        area: area,
        type: GO_TO_PAGE,
        pageIndex: pageIndex
    };
}

function setPageSize(area, pageSize) {
    return {
        area: area,
        type: SET_PAGE_SIZE,
        pageSize: pageSize
    };
}

function setItemsCount(area, itemsCount) {
    return {
        area: area,
        type: SET_ITEMS_COUNT,
        itemsCount: itemsCount
    };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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